export const REBORROW_FLAG = {
  0: '未复借',
  1: '已复借'
}
export const REBORROW_FLAG_EN = {
  0: 'Not re-borrowed',
  1: 'Has been reborrowed'
}

export const REBORROW_FLAG_TI = {
  0: 'กู้คืนไม่ได้',
  1: 'ชำระเงินเรียบร้อยแล้ว'
}


export const SEX = {
  '0': '先生',
  '1': '小姐',
  '2': '女士'
}

// export const CONTACT_TYPE = {
//   0: 'firstContact',
//   1: 'secondContact',
//   2: 'thirdContact',
//   3: 'fourthContact'
// }

export const TRADESTATUS = {
  '00': '交易中',
  '01': '交易成功',
  '02': '交易退款',
  '03': '交易取消',
  '04': '交易失败',
  '05': '交易队列中'
}

export const TRADETYPE = {
  '0': '提现',
  '1': '存款'
}

export const ORDER_TYPE = {
  '0': 'Orden normal',
  '1': 'Orden de prórroga'
}

export const ORDER_TYPE_CN = {
  '0': '正常订单',
  '1': '展期订单'
}
export const ORDER_TYPE_EN = {
  '0': 'Normal order',
  '1': 'Extended order'
}
export const ORDER_TYPE_TI = {
  '0': 'คําสั่งปกติ',
  '1': 'คําสั่งช่วงแสดง'
}
export const STATUS_TYPE = {
  0: '否',
  1: '是'
}
export const REFUND_TRADE_STATUS = {
  '00': '交易中',
  '01': '交易成功',
  '02': '交易退款',
  '03': '交易取消',
  '04': '交易提交',
  '05': '交易失败'
}

export const CURP_TYPE = {
  '0': 'CC',
  '1': 'CE',
  '2': 'TI',
  '3': 'NIT',
  '4': 'Pasaporte'
}

export const COLLECT_TYPE = {
  '1': 'BANK',
  '2': 'NEQUI'

}

export const PAYOUT_STATUS = {
  '00': '发起放款',
  '01': '放款成功',
  '02': '放款失败'
}

export const REPAY_STATUS = {
  '00': '发起支付',
  '01': '支付成功',
  '02': '支付失败',
  '03': '待支付'
}

export const PAYTYPE = {
  '00': '正常还款',
  '01': '展期还款',
  '02': '部分还款'
}
export const ContactPerson_FLAG = {
  '0': '联系人 1',
  '1': '联系人 2',
  '2': '联系人 3',
  '3': '联系人 4',
  '本人':'本人',
}
export const ContactPerson_FLAG_EN = {
  '0': 'Contact 1',
  '1': 'Contact 2',
  '2': 'Contact 3',
  '3': 'Contact 4',
  '本人':'Contact person',
}

export const ContactPerson_FLAG_TI = {
  '0': 'ผู้ติดต่อบุคคลที่ 1',
  '1': 'ผู้ติดต่อบุคคลที่ 2',
  '2': 'ผู้ติดต่อบุคคลที่ 3',
  '3': 'ผู้ติดต่อบุคคลที่ 4',
  '本人':'ตัวเอง',
}

export const BANK_CARD_TYPE = {
  '0': '储蓄卡'
}


